import createSagaMiddleware from "redux-saga";
import { Store, applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import { push } from 'connected-react-router';

import rootSaga from "../sagas/index";
import createRootReducer from "../reducers";
import { IApplicationState } from "../../interfaces";

import { ActionTypes } from '../../constants/ActionTypes'

const createBrowserHistory = require("history").createBrowserHistory;

export const history = createBrowserHistory();

const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const middlewares = [thunk, sagaMiddleware, routeMiddleware];

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const resetEnhancer = (rootReducer: any) => (state: any, action: any) => {

  if (action.type !== ActionTypes.DESTROY_SESSION) {
    return rootReducer(state, action);
  }

  const newState = rootReducer(undefined, {});
  newState.router = state.router;
  state.settings.pathname = "/loading";
  newState.settings = state.settings;

  return newState;
}

export default function configureStore(
  preloadedState: IApplicationState
): Store<IApplicationState> {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(
    resetEnhancer(createRootReducer(history)), // root reducer with router state
    preloadedState,
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        ...middlewares
      )
    )
  );

  sagaMiddleware.run<any>(rootSaga);
  return store;
}
